// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__3kE8x","your-choice":"styles_your-choice__3qyb8","label":"styles_label__1pgnM"};